export const MapIcon = () => {
    return (
        <svg
            width="18"
            height="22"
            viewBox="0 0 18 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.99994 0.100861C6.72393 0.104563 4.5422 1.01035 2.93281 2.61973C1.32342 4.22912 0.417643 6.41085 0.41394 8.68686C0.41394 13.2789 8.19494 21.3549 8.52594 21.6989C8.58754 21.7622 8.66123 21.8126 8.74265 21.847C8.82407 21.8814 8.91155 21.8992 8.99994 21.8992C9.08833 21.8992 9.17582 21.8814 9.25723 21.847C9.33865 21.8126 9.41234 21.7622 9.47394 21.6989C9.80494 21.3549 17.5859 13.2799 17.5859 8.68686C17.5822 6.41085 16.6765 4.22912 15.0671 2.61973C13.4577 1.01035 11.276 0.104563 8.99994 0.100861ZM8.99994 11.9899C8.34726 11.9899 7.70924 11.7963 7.16656 11.4337C6.62388 11.0711 6.20091 10.5557 5.95114 9.95272C5.70137 9.34972 5.63602 8.6862 5.76335 8.04606C5.89068 7.40593 6.20498 6.81792 6.66649 6.35641C7.128 5.8949 7.716 5.5806 8.35614 5.45327C8.99628 5.32594 9.6598 5.39129 10.2628 5.64106C10.8658 5.89083 11.3812 6.3138 11.7438 6.85648C12.1064 7.39916 12.2999 8.03718 12.2999 8.68986C12.2999 9.56508 11.9523 10.4044 11.3334 11.0233C10.7145 11.6422 9.87516 11.9899 8.99994 11.9899Z"
                fill="#9B9B9B"
            />
        </svg>
    );
};
